import React from "react";
import { Box, Typography, Paper, Grid, Divider, Avatar, IconButton, Tooltip, } from "@mui/material";
import baseURL from "../../config";
import Navbar from "../../Navbar/Navbar";
import EditIcon from "@mui/icons-material/Edit";

const SeaServiceProfileDetails = ({ data, onEditClick }) => {
  return (
    <>
      <Navbar />
      <Box
        component={Paper}
        elevation={4}
        sx={{
          p: 4,
          mt: 6,
          maxWidth: 700,
          mx: "auto",
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          position: "relative" // ✅ This enables absolute positioning of EditIcon
        }}
      >
        <Tooltip title="Edit Profile">
          <IconButton
            onClick={onEditClick}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>

        <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center">
          Sea Service Profile
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Company Name
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {data.companyName}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Authorized Signatory
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {data.authorisedSignatoryName}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Mobile Number
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {data.mobileNumber}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Address
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {data.address}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {data.email}
            </Typography>
          </Grid>

          {data.logo?.filePath && (
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Company Logo
              </Typography>
              <Avatar
                alt="Logo"
                src={`${baseURL}/${data.logo.filePath}`}
                variant="rounded"
                sx={{ width: 120, height: 120, mx: "auto", border: "1px solid #ccc" }}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default SeaServiceProfileDetails;
